import React, { useState, useLayoutEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import { Box, Grid } from '@mui/material';
import PageTitle from '@/components/common/PageTitle';
import Loading from '@/components/common/Loading';
import URL from '@/common/routes/Url';
import CommonTableContainer from '@/components/common/CommonTableContainer';
import Tenant from '@/types/Tenant.type';
import TenantService from '@/services/Tenant.service';
import TenantTableBody from '@/components/tenant/TenantTableBody';

const TenantList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [tenants, setTenants] = useState<Array<Tenant>>([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const getTenant = () => {
    TenantService.getAll()
      .then((response) => {
        setTenants(response.data);
        setLoading(false);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });
  };

  useLayoutEffect(() => {
    getTenant();
  }, []);

  const editTenant = (id: number) => {
    navigate(`${URL.tenants}/${id}`);
  };

  const employeeTableHeads = ['会社名', 'システム管理者名', '契約プラン', '利用開始日', '利用停止日', ''];
  const employeeTableBody = <TenantTableBody onEdit={editTenant} rows={tenants} />;

  if (loading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>テナント管理</PageTitle>
        </Box>
        <Box sx={{ marginBottom: '8px' }}>
          <p>テナント管理</p>
          <Button variant="contained" color="primary" onClick={() => navigate(`${URL.tenants}/add`)}>
            追加画面へ
          </Button>
        </Box>
        <CommonTableContainer tableHeads={employeeTableHeads} tableBody={employeeTableBody} />
      </Grid>
    </Grid>
  );
};
export default TenantList;
